import { BookingStatus } from '@/config'
import { BookingSummary } from '@/services/BookingService.interface'

function normalizeBookingRefToken(value: string): string {
  return value.trim().toUpperCase()
}

export type BookingReferenceParams = Pick<
  BookingSummary,
  'reference' | 'extReferenceBO'
> & {
  externalReference?: string | null
  status?: BookingSummary['status']
}

/**
 * Booking not in iResa yet: IRESA `reference` and BO `extReferenceBO` are the same TF token.
 */
export function isBookingNotYetInIresa(
  booking: BookingReferenceParams | null | undefined
): boolean {
  if (!booking) return false

  const reference = normalizeBookingRefToken(String(booking.reference ?? ''))
  const extReferenceBO = normalizeBookingRefToken(
    String(booking.extReferenceBO ?? booking.externalReference ?? '')
  )

  return (
    reference.length > 0 &&
    extReferenceBO.length > 0 &&
    reference === extReferenceBO
  )
}

/** Reservation (status 2) where TF reference still equals BO reference (transfer not complete). */
export function isPendingIresaTransferReservation(
  booking: BookingSummary | null | undefined
): boolean {
  if (!booking) return false
  if (booking.status !== BookingStatus.Reservation) return false
  return isBookingNotYetInIresa(booking)
}
